import { render, staticRenderFns } from "./PartnerInquiryCategoryReg.vue?vue&type=template&id=8ca2d1fa&scoped=true"
import script from "./PartnerInquiryCategoryReg.vue?vue&type=script&lang=js"
export * from "./PartnerInquiryCategoryReg.vue?vue&type=script&lang=js"
import style0 from "./PartnerInquiryCategoryReg.vue?vue&type=style&index=0&id=8ca2d1fa&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca2d1fa",
  null
  
)

export default component.exports